import React from 'react';
import { TargetIcon, TreesIcon, HomeIcon, BowArrowIcon, ClockIcon } from 'lucide-react';
export function FacilitiesSection() {
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#2d5a3d'
  }} aria-label="Facilities" data-id="element-126">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-127">
        <div className="text-center mb-12" data-id="element-128">
          <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{
          color: '#c8a84b',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-129">
            World-Class Facilities
          </p>
          <h2 className="text-3xl md:text-4xl font-bold uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#ffffff'
        }} data-id="element-130">
            Our Facilities
          </h2>
          <div className="section-divider-center" data-id="element-131" />
          <p className="text-base max-w-2xl mx-auto" style={{
          color: '#a0c8b0',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-132">
            Over 70 acres of rolling Michigan countryside, purpose-built for
            shooting sports and outdoor recreation.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-133">
          {/* Indoor Pistol Range */}
          <div className="rounded-2xl p-6" style={{
          backgroundColor: 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(255,255,255,0.12)'
        }} data-id="element-134">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(200,168,75,0.15)'
          }} data-id="element-135">
              <TargetIcon size={24} style={{
              color: '#c8a84b'
            }} data-id="element-136" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-137">
              Indoor Pistol Range
            </h3>
            <p className="text-sm mb-3" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-138">
              6 lanes · 50 feet · Members &amp; guests
            </p>
            <div className="flex items-center gap-2 text-xs font-semibold px-3 py-1.5 rounded-full w-fit" style={{
            backgroundColor: 'rgba(200,168,75,0.15)',
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-139">
              <ClockIcon size={11} data-id="element-140" />
              24/7 Member Access
            </div>
          </div>

          {/* Outdoor Rifle & Pistol */}
          <div className="rounded-2xl p-6" style={{
          backgroundColor: 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(255,255,255,0.12)'
        }} data-id="element-141">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(200,168,75,0.15)'
          }} data-id="element-142">
              <TargetIcon size={24} style={{
              color: '#c8a84b'
            }} data-id="element-143" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-144">
              Outdoor Rifle &amp; Pistol
            </h3>
            <p className="text-sm mb-3" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-145">
              25, 50, and 100 yard ranges. Rifle, Pistol, Muzzle Loaders, and
              Shotgun.
            </p>
            <div className="text-xs font-semibold px-3 py-1.5 rounded-full w-fit" style={{
            backgroundColor: 'rgba(200,168,75,0.15)',
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-146">
              Mon–Sat 9am to Sundown · Sun 9am–5pm
            </div>
          </div>

          {/* Sporting Clays */}
          <div className="rounded-2xl p-6" style={{
          backgroundColor: 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(255,255,255,0.12)'
        }} data-id="element-147">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(200,168,75,0.15)'
          }} data-id="element-148">
              <TreesIcon size={24} style={{
              color: '#c8a84b'
            }} data-id="element-149" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-150">
              Sporting Clays Course
            </h3>
            <p className="text-sm mb-3" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-151">
              16 stations · 1-mile wooded course. Public access on weekends.
            </p>
            <div className="text-xs font-semibold px-3 py-1.5 rounded-full w-fit" style={{
            backgroundColor: 'rgba(200,168,75,0.15)',
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-152">
              Public Weekends 10am–3pm
            </div>
          </div>

          {/* 3D Archery */}
          <div className="rounded-2xl p-6" style={{
          backgroundColor: 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(255,255,255,0.12)'
        }} data-id="element-153">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(200,168,75,0.15)'
          }} data-id="element-154">
              <BowArrowIcon size={24} style={{
              color: '#c8a84b'
            }} data-id="element-155" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-156">
              3D Archery Course
            </h3>
            <p className="text-sm mb-3" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-157">
              Open summer and fall. Public access on weekends. Also features Axe
              &amp; Knife Throwing.
            </p>
            <div className="text-xs font-semibold px-3 py-1.5 rounded-full w-fit" style={{
            backgroundColor: 'rgba(200,168,75,0.15)',
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-158">
              Summer &amp; Fall
            </div>
          </div>

          {/* Rental Hall */}
          <div className="rounded-2xl p-6" style={{
          backgroundColor: 'rgba(255,255,255,0.08)',
          border: '1px solid rgba(255,255,255,0.12)'
        }} data-id="element-159">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(200,168,75,0.15)'
          }} data-id="element-160">
              <HomeIcon size={24} style={{
              color: '#c8a84b'
            }} data-id="element-161" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-162">
              Rental Hall
            </h3>
            <p className="text-sm mb-3" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-163">
              300-person capacity. Includes outdoor pavilion. Available for
              meetings, receptions, graduations &amp; more.
            </p>
            <div className="text-xs font-semibold px-3 py-1.5 rounded-full w-fit" style={{
            backgroundColor: 'rgba(200,168,75,0.15)',
            color: '#c8a84b',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-164">
              Member Discount Available
            </div>
          </div>

          {/* Law Enforcement */}
          <div className="rounded-2xl p-6" style={{
          backgroundColor: 'rgba(200,168,75,0.1)',
          border: '1px solid rgba(200,168,75,0.25)'
        }} data-id="element-165">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(200,168,75,0.2)'
          }} data-id="element-166">
              <TargetIcon size={24} style={{
              color: '#c8a84b'
            }} data-id="element-167" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-168">
              Law Enforcement Training
            </h3>
            <p className="text-sm" style={{
            color: '#a0c8b0',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-169">
              Facilities available to local law enforcement for training,
              certification, and qualification.
            </p>
          </div>
        </div>
      </div>
    </section>;
}